import clsx from 'clsx';
import { isEmptyObject } from './object.js';

/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
function mergeProps(...args) {
    const n = args.length;
    let start = 0;
    let first;
    // Start by finding the first non-empty object
    for (; start < n; ++start) {
        first = args[start];
        if (first && !isEmptyObject(first))
            break;
    }
    // Check if there are any non-empty objects after the first one
    let allRemainingEmpty = true;
    for (let i = start + 1; i < n; ++i) {
        const arg = args[i];
        if (arg && !isEmptyObject(arg)) {
            allRemainingEmpty = false;
            break;
        }
    }
    // If we didn't find any non-empty objects, return the first one
    if (allRemainingEmpty)
        return first || {};
    // We're in the process of constructing. Let's use tests to ensure type safety here instead of TS.
    const merged = { ...first };
    for (let i = start + 1; i < n; ++i) {
        const props = args[i];
        for (const key in props) {
            // If it's only in the right side, add it.
            if (!merged[key]) {
                merged[key] = props[key];
            }
            else {
                // If `key` is in both...
                // Merge `on*` handlers so both are called.
                if (key.match(/^on[A-Z]/)) {
                    merged[key] = mergeCallbacks(merged[key], props[key]);
                }
                else if (key === 'className') {
                    merged[key] = clsx(merged[key], props[key]);
                }
                else if (key === 'style') {
                    merged[key] = { ...merged[key], ...props[key] };
                }
                else {
                    // else, we just clobber the key
                    merged[key] = props[key];
                }
            }
        }
    }
    return merged;
}
/**
 * Left-to-right merge of style objects. Skips nullish entries and returns `undefined` when no
 * input contributes anything. Returns the single non-nullish input by reference when possible,
 * avoiding a copy. Guaranteed to only allocate one new object when necessary.
 */
function mergeStyles(...styles) {
    const n = styles.length;
    if (n <= 2) {
        if (!styles[1])
            return styles[0] || undefined;
        if (!styles[0])
            return styles[1] || undefined;
        return { ...styles[0], ...styles[1] };
    }
    let i = 0;
    for (; i < n; ++i)
        if (styles[i])
            break;
    // No truthy styles found
    if (i >= n)
        return undefined;
    let merged = styles[i++];
    for (; i < n; ++i) {
        if (styles[i]) {
            merged = { ...merged, ...styles[i++] };
            break;
        }
    }
    for (; i < n; ++i) {
        if (styles[i])
            Object.assign(merged, styles[i]);
    }
    return merged;
}
function mergeCallbacks(fnA, fnB) {
    if (!fnA && !fnB)
        return undefined;
    if (!fnA)
        return fnB;
    if (!fnB)
        return fnA;
    return (...args) => {
        fnA(...args);
        fnB(...args);
    };
}

export { mergeProps, mergeStyles };
//# sourceMappingURL=merge-props.js.map
